import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgJhipsterModule } from 'ng-jhipster';
import { CookieModule } from 'ngx-cookie';

@NgModule({
    imports: [
        NgbModule.forRoot(),
        // NgJhipsterModule.forRoot({
        //     // set below to true to make alerts look like toast
        //     alertAsToast: false,
        //     i18nEnabled: true,
        //     defaultI18nLang: 'vi'
        // }),
        CookieModule.forRoot()
    ],
    exports: [
        FormsModule,
        HttpModule,
        CommonModule,
        NgbModule,
        // NgJhipsterModule,
    ]
})
export class WebAppSharedLibsModule {}
